export enum CodStatusBillingReport {
  REALIZADA = 'REALIZADA',
  EN_PROCESO = 'EN_PROCESO',
}

export const tagStatusDictionaryBillingReport = {
  REALIZADA: 'completed',
  EN_PROCESO: 'pending',
};
